import { render, staticRenderFns } from "./DetailDownTime.vue?vue&type=template&id=ecda3108"
import script from "./DetailDownTime.vue?vue&type=script&lang=js"
export * from "./DetailDownTime.vue?vue&type=script&lang=js"
import style0 from "./DetailDownTime.vue?vue&type=style&index=0&id=ecda3108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports